
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray, tryFind, map, exists, filter } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Hierarchy_buildTreeOrderedList, Hierarchy_getDescendants } from "../../../Shared/Category.js";
import { FormContainer } from "../../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../../Components/Input.js";
import { Msg } from "./Types.js";
import { unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { LabelId__get_unwrap, FormState__getValidation } from "../../../Shared/Shared.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SelectWithColor } from "../../../Components/Select.js";
import { Badge } from "../../../Components/Badge.js";
import { Button } from "../../../Components/Button.js";
import { ColorPicker_colorPicker_BD3CF72 } from "../../../SharedComponents/ReactColorPicker.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { ErrorAlert, InformationAlert } from "../../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { withoutOnboardingTourQueryParams, isCategoryLabelsTourFormPhase } from "../../../Common.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../../Components/TourGuide.js";

export function CategoryForm(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const colorSelectorOpen = patternInput_1[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const availableParentCategories = filter((c) => {
        let candidateId, matchValue, currentId;
        return !((candidateId = c.Id, (matchValue = props.CategoryId, (matchValue == null) ? false : ((currentId = matchValue, exists((d) => equals(d.Id, candidateId), Hierarchy_getDescendants(props.AllCategories, currentId)) ? true : equals(candidateId, currentId))))));
    }, props.AllCategories);
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("category.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "category-form-name",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Category.Name,
        })), delay(() => {
            const treeOptions = map((tupledArg) => {
                const c_1 = tupledArg[0];
                return {
                    color: c_1.ColorHex,
                    label: concat(Array((tupledArg[1] * 4) + 1).join(" "), ...c_1.Name),
                    value: c_1.Id,
                };
            }, Hierarchy_buildTreeOrderedList(availableParentCategories));
            let selectedParentOption;
            const matchValue_1 = props.Category.ParentLabelId;
            if (matchValue_1 == null) {
                selectedParentOption = undefined;
            }
            else {
                const parentId = matchValue_1;
                selectedParentOption = tryFind((o) => equals(o.value, parentId), treeOptions);
            }
            return append(singleton(createElement(SelectWithColor, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("category.parent_category"),
                NoOptionsMessage: "category.no_parent_category_available",
                OnChange: (selected) => {
                    if (selected == null) {
                        props.Dispatch(new Msg(3, [undefined]));
                    }
                    else {
                        props.Dispatch(new Msg(3, [selected.value]));
                    }
                },
                Options: treeOptions,
                PlaceholderKey: "category.parent_category_placeholder",
                TestId: "category-parent-select",
                Value: unwrap(selectedParentOption),
            })), delay(() => {
                let elems_1, elems;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_1 = [reactElement("div", {
                    className: join(" ", ["font-bold", "mb-1"]),
                    children: t("category.color"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-20"])], (elems = [createElement(Badge, {
                    Color: props.Category.ColorHex,
                    Label: props.Category.ColorHex,
                    TestId: "new-category-test-id",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_3;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = toList(delay(() => {
                        let elems_2;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_2 = [createElement(Button, {
                            ComponentState: componentState,
                            Label: t("category.choose_color"),
                            OnClick: () => {
                                patternInput_1[1](!colorSelectorOpen);
                            },
                            TestId: "settings-choosecolor-button",
                            Variant: "secondary",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => (colorSelectorOpen ? singleton(ColorPicker_colorPicker_BD3CF72((color) => {
                            props.Dispatch(new Msg(1, [color.hex]));
                        }, props.Category.ColorHex)) : empty())));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append(singleton(Checkbox({
                        ComponentState: componentState,
                        IsChecked: props.Category.VisibleForUserRole,
                        Label: t("category.visible_for_user"),
                        OnCheck: (arg_1) => {
                            props.Dispatch(new Msg(2, [arg_1]));
                        },
                        TestId: "",
                    })), delay(() => append(singleton(createElement(InformationAlert, {
                        Label: t("category.visible_for_user_tooltip"),
                    })), delay(() => {
                        const matchValue_2 = FormState__getValidation(props.FormState, t, "global");
                        if (matchValue_2 == null) {
                            return empty();
                        }
                        else {
                            return singleton(createElement(ErrorAlert, {
                                Label: matchValue_2,
                            }));
                        }
                    }))))));
                }));
            }));
        })))),
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewCategoryView() {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const patternInput_2 = reactApi.useState(false);
    const setCategoryLabelsFormTourDismissed = patternInput_2[1];
    const showCategoryLabelsFormTour = isCategoryLabelsTourFormPhase() && !patternInput_2[0];
    const clearCategoryLabelsTourFromUrl = () => {
        RouterModule_nav(ofArray(["settings", "categories", "new" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
    };
    const matchValue = state_1.AllCategories;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => append(singleton(createElement(CategoryForm, {
            AllCategories: matchValue.fields[0],
            Category: state_1.CategoryForm,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            Header: t("category.create"),
            OnBack: () => {
                RouterModule_nav(ofArray(["settings", "categories"]), 1, 1);
            },
            OnSave: () => {
                dispatch(new Msg(4, []));
            },
        })), delay(() => {
            let Steps;
            return showCategoryLabelsFormTour ? singleton(createElement(TourGuide, (Steps = ofArray([new TourStep("[data-test-id=\'category-form-name\']", t("onboarding.tour.category_form_name_title"), reactElement("div", {
                children: t("onboarding.tour.category_form_name_content"),
            }), "bottom", true), new TourStep("[data-test-id=\'category-parent-select\']", t("onboarding.tour.category_form_parent_title"), reactElement("div", {
                children: t("onboarding.tour.category_form_parent_content"),
            }), "bottom", true)]), {
                IsRunning: true,
                Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                OnFinish: () => {
                    setCategoryLabelsFormTourDismissed(true);
                    clearCategoryLabelsTourFromUrl();
                },
                OnSkip: () => {
                    setCategoryLabelsFormTourDismissed(true);
                    clearCategoryLabelsTourFromUrl();
                },
                ScrollFirstStep: false,
                Steps: Steps,
            }))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

export function EditCategoryView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.CategoryId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue_1 = state_1.AllCategories;
    let matchResult, allCategories;
    if (state_1.Category.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            allCategories = matchValue_1.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(CategoryForm, {
                AllCategories: allCategories,
                Category: state_1.CategoryForm,
                CategoryId: props.CategoryId,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("category.edit"),
                OnBack: () => {
                    RouterModule_nav(ofArray(["settings", "categories", LabelId__get_unwrap(props.CategoryId)]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(5, []));
                },
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

